<template>
    <div class="tipo-notificacion">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="90%" scrollable>
                    <v-card>
                        <template>
                            <v-toolbar color="primary" dark flat>
                                <v-toolbar-title>
                                    <v-icon medium>fa fa-cog</v-icon>
                                    Lista de Tipos de notificación
                                </v-toolbar-title>

                                <v-divider class="mx-2" inset vertical></v-divider>

                                <v-flex sm3 class="pa-0" style="max-width: 190px">
                                    <v-overflow-btn
                                        v-model="tipoNotificacionEstado"
                                        label="Tipo de notificación"
                                        :items="[
                                            { text: 'Todos', value: '1' },
                                            { text: 'Habilitados', value: '2' },
                                            { text: 'Deshabilitados', value: '3' }
                                        ]"
                                        hide-details
                                        class="pa-0"
                                        @change="loadTipoNotificacion()"
                                    >
                                        <template v-slot:item="data">
                                            <v-list-tile-content>
                                                <v-card-text class="pa-0 ">
                                                    <v-icon
                                                        :color="getIconColor(data)"
                                                        class="pr-3"
                                                        v-if="data.item.value !== '1'"
                                                        >fa-list
                                                    </v-icon>
                                                    {{ data.item.text }}
                                                </v-card-text>
                                            </v-list-tile-content>
                                        </template>
                                    </v-overflow-btn>
                                </v-flex>

                                <v-divider class="px-1" inset vertical></v-divider>

                                <v-spacer></v-spacer>

                                <v-toolbar-items>
                                    <v-btn icon @click="toogleSearch()">
                                        <v-icon medium>fa-search</v-icon>
                                    </v-btn>

                                    <v-expand-x-transition>
                                        <v-text-field
                                            hide-details
                                            solo
                                            v-show="searchShow"
                                            v-model="filter.search"
                                            placeholder="Filtrar"
                                            class="hidden-sm-and-down pt-2"
                                        >
                                        </v-text-field>
                                    </v-expand-x-transition>

                                    <v-divider class="pa-2"></v-divider>

                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon flat @click="openForm(null)">
                                                <v-icon medium v-on="on">fa-plus</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Agregar Tipo de notificación</span>
                                    </v-tooltip>
                                </v-toolbar-items>
                            </v-toolbar>
                            <v-divider></v-divider>
                            <v-card-text class="pa-0">
                                <v-data-table
                                    :headers="headers"
                                    :loading="loading"
                                    :pagination.sync="pagination"
                                    :rows-per-page-items="pagination.rowsPerPageItems"
                                    :total-items="totalItems"
                                    :items="TIPOS_NOTIFICACION"
                                    class="elevation-1"
                                    item-key="id"
                                >
                                    <v-progress-linear v-slot:progress color="green" indeterminate></v-progress-linear>
                                    <template slot="items" slot-scope="props">
                                        <tr>
                                            <td>{{ getCategoriaValue(props.item) }}</td>
                                            <td>
                                                <v-chip
                                                    small
                                                    dark
                                                    :color="getChipColor(props.item)"
                                                    style="font-size: 12px"
                                                >
                                                    {{
                                                        props.item.status_description
                                                            ? props.item.status_description
                                                            : "-"
                                                    }}
                                                </v-chip>
                                            </td>
                                            <td class="pl-0">
                                                <v-layout class="justify-end">
                                                    <div class="action-column" style="width: 156px">
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on }">
                                                                <v-btn
                                                                    flat
                                                                    icon
                                                                    color="orange"
                                                                    :disabled="loading || menuLocked"
                                                                    @click="openForm(props.item)"
                                                                >
                                                                    <v-icon medium v-on="on">fa-edit</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Editar Tipo de notificación</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on }">
                                                                <v-btn
                                                                    flat
                                                                    icon
                                                                    color="red"
                                                                    :disabled="loading || menuLocked"
                                                                    @click="deleteItem(props)"
                                                                >
                                                                    <v-icon medium v-on="on">fa-trash</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Eliminar Tipo de notificación</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on }">
                                                                <v-btn
                                                                    flat
                                                                    icon
                                                                    color="grey"
                                                                    :loading="loadingHistory"
                                                                    :disabled="loading || menuLocked"
                                                                    @click="loadHistory(props.item)"
                                                                >
                                                                    <v-icon medium v-on="on">fa-archive</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Ver historial</span>
                                                        </v-tooltip>
                                                    </div>
                                                </v-layout>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-slot:expand="props">
                                        <v-card>
                                            <v-card-text class="py-0 pl-0 text-xs-right">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn icon flat color="red" @click="deleteItemCancel(props)">
                                                            <v-icon v-on="on">fa-close</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Cancelar acción</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            icon
                                                            flat
                                                            color="green"
                                                            @click="deleteItemConfirm(props)"
                                                        >
                                                            <v-icon v-on="on">fa-check</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Confirmar acción</span>
                                                </v-tooltip>
                                            </v-card-text>
                                        </v-card>
                                    </template>
                                    <template slot="no-data">
                                        <div style="text-align: center">
                                            No existen tipos de notificación registrados en el sistema.
                                        </div>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </template>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>

        <tipo-notificacion-form
            v-if="showTipoNotificacionForm"
            :form-title="title"
            :initial-item="editItem"
            @formCanceled="closeForm"
        ></tipo-notificacion-form>

        <time-line
            v-if="showHistory"
            :data="historyData"
            :element="'Tipo de notificación'"
            @formCanceled="showHistory = false"
        ></time-line>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import _ from "lodash"
import Util from "@/util"
const TipoNotificacionForm = () => import("@/components/notificacion/tipo-notificacion-form")
const TimeLine = () =>
    import(/* webpackChunkName: "historiales-time-line" */ "@/components/widgets/records-time-line/time-line")
export default {
    components: { TipoNotificacionForm, TimeLine },
    data: () => ({
        searchShow: false,
        loading: false,
        headers: [{ text: "Categoría", value: "categoria" }, { text: "Estado", value: "estado" }, { sortable: false }],
        filter: {
            search: ""
        },
        totalItems: 0,

        deleteConfirmId: "",

        menuLocked: false,

        //estado de los tipo de notificacions a cargar del back
        tipoNotificacionEstado: "2",

        //history
        loadingHistory: false,
        showHistory: false,
        historyData: null,

        //formulario de insertar y modificar
        showTipoNotificacionForm: false,
        title: "",
        editItem: null
    }),

    methods: {
        toogleSearch: function() {
            this.searchShow = !this.searchShow
        },

        loadData(estado) {
            this.loading = true
            this.$store
                .dispatch("LOAD_TIPOS_NOTIFICACION", { filter: this.filter.search, tipoNotificacionEstado: estado })
                .then(result => {
                    this.loading = false
                    this.totalItems = result
                })
        },

        openForm(item) {
            if (item !== null) {
                this.title = "Modificar Tipo de notificación"
                this.editItem = item
            } else {
                this.title = "Nuevo Tipo de notificación"
            }
            this.showTipoNotificacionForm = true
        },

        deleteItem(props) {
            this.menuLocked = true
            this.deleteConfirmId = props.item.id
            props.expanded = true
        },

        deleteItemConfirm(props) {
            if (this.deleteConfirmId === props.item.id) {
                this.loading = true
                this.$store.dispatch("DELETE_TIPO_NOTIFICACION", props.item).then(() => {
                    this.loading = false
                    this.menuLocked = false
                    this.deleteConfirmId = ""
                    props.expanded = !props.expanded
                })
            }
        },

        deleteItemCancel(props) {
            this.menuLocked = false
            this.deleteConfirmId = ""
            props.expanded = !props.expanded
        },

        loadTipoNotificacion() {
            this.loadData(this.tipoNotificacionEstado)
        },

        loadHistory(item) {
            this.loadingHistory = true

            let historyClassName = Util.getHistoryClassName("TipoNotificacion")
            this.$store.commit("SET_HISTORIALES_TIME_LINE_PAG", { page: 1 })
            this.$store
                .dispatch("LOAD_HISTORIALES_TIME_LINE", { class: historyClassName, class_id: item.id })
                .then(response => {
                    if (response) {
                        this.historyData = this.$store.getters.HISTORIALES_TIME_LINE.historiales
                        this.showHistory = true
                        this.loadingHistory = false
                    } else {
                        this.loadingHistory = false
                    }
                })
        },

        searchData: _.debounce(function() {
            this.loadData(this.tipoNotificacionEstado)
        }, 1000),

        getChipColor(item) {
            switch (item.estado) {
                case 1:
                    return "success lighten-1"
                case 0:
                    return "grey lighten-1"
            }
        },

        getIconColor(data) {
            switch (data.item.value) {
                case "1":
                    return "black"
                case "2":
                    return "success lighten-1"
                case "3":
                    return "grey lighten-1"
                default:
                    return "black"
            }
        },

        cancelForm() {
            this.$emit("formCanceled")
        },

        closeForm() {
            this.showTipoNotificacionForm = false
            this.editItem = null
        },

        getCategoriaValue(item) {
            if (item && item.categoria) {
                return Util.getNotificationCategorie(null, item.categoria, this.BD_TABLES)
            } else return " "
        }
    },

    computed: {
        ...mapGetters(["TIPOS_NOTIFICACION", "BD_TABLES"]),

        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        },

        pagination: {
            get: function() {
                return this.$store.getters.TIPOS_NOTIFICACION_PAG
            },
            set: function(value) {
                this.$store.commit("SET_TIPOS_NOTIFICACION_PAG", value)
            }
        },

        searchTerm() {
            return this.filter.search
        }
    },

    watch: {
        pagination: {
            handler() {
                this.loadData(this.tipoNotificacionEstado)
            },
            deep: true
        },
        searchTerm() {
            this.searchData()
        }
    },

    created() {
        this.$store.dispatch("LOAD_BD_TABLES")
    }
}
</script>
